import { gql } from '@apollo/client';

const UPDATE_SUPPLIER_STATUS_SORTORDER = gql`mutation updateSortOrder ($input: [SupplierOrderStatusSortInput] ){
	incomingOrders
	{
		updateSupplierOrderStatusSortOrder(input:$input)
	}
}`;

export default UPDATE_SUPPLIER_STATUS_SORTORDER;